import React from 'react';

export const GoogleMap = ({ address, className = '' }) => {
  // Encode the address for the Google Maps embed URL
  const encodedAddress = encodeURIComponent(address || '23 rue du Dauphiné, 69003 Lyon, France');
  
  return (
    <div className={`google-map-container ${className}`}>
      <iframe
        title="Localisation Réseau d'Aide à Domicile"
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodedAddress}&zoom=15`}
        width="100%"
        height="400"
        style={{ border: 0, borderRadius: '16px' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default GoogleMap;
